// extracted by mini-css-extract-plugin
export default {"wrapper":"RZ5jg33qe4AJCnGv8OD2"};